import React from 'react';
import Head from 'next/head.js';

import { ClientContext } from '../../helpers/clientContext';
import styles from './DirectAccessNavigator.module.scss';

type DirectAccessNavigatorProps = {
  clientContext: ClientContext;
};

export const DirectAccessNavigator = ({ clientContext }: DirectAccessNavigatorProps) => {
  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
        <meta name="googlebot" content="noindex" />
        <title>Haven Login</title>
      </Head>
      <div className={styles.mainContainer}>
        <h1>Let&apos;s Guide You to the Right Place</h1>
        <p>
          You&apos;ve landed somewhere unexpected, but not to worry, we&apos;ve a great Haven
          experience for you just ahead! Select where to go next:
        </p>
        <div className={styles.items}>
          <div className={styles.item}>
            <img
              alt="Continue to haven.com"
              width="288"
              height="180"
              src="https://bynder.haven.com/transform/d0450d5e-0523-453c-bde6-daef9fbbab8b/hm_seasidetreats_corefam_04_2025?io=transform:fill,width:576,height:360,gravity:center&format=jpg&quality=90"
            />
            <div className={styles.text}>
              <a href={clientContext.havenStartAuth}>Continue to haven.com</a>
            </div>
          </div>
          <div className={styles.item}>
            <img
              alt="Continue to the Ownership hub"
              width="288"
              height="180"
              src="https://bynder.haven.com/transform/c0c1b273-99ea-498e-b4c8-0479c6ceb033/Default-CS-Brochure-Hero-Image?io=transform:fill,width:576,height:360,gravity:center&format=jpg&quality=90"
            />
            <div className={styles.text}>
              <a href={clientContext.ownersStartAuth}>Continue to the Ownership hub</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectAccessNavigator;
